import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { SplashScreen } from 'src/components/loading-screen';
//
import { store, persistor } from './store';

// ----------------------------------------------------------------------

export default function ReduxProvider({ children }) {
  return (
    <Provider store={store}>
      <PersistGate
        loading={<SplashScreen message="Préparation de l'application..." />}
        persistor={persistor}
      >
        {children}
      </PersistGate>
    </Provider>
  );
}
